import React from "react";
import { BsFillDiamondFill } from "react-icons/bs";
import activeToken from "../../assets/active-token.png";
import handIcon from "../../assets/handIcon.png";

function Timeline(props) {
  return (
    <div className="relative wrap overflow-hidden p-5 md:p-10">
      <div
        className={`border-2-2 absolute left-[10px] md:left-[70px] top-[-20px] border-gray-700 ${props.height} border`}
      ></div>
      <div className="mb-8 w-full ">
        <div className="order-1 w-5/12 md:w-5/12"></div>

        <div className="order-1 bg-[#121127] text-white  w-full px-5 md:px-[100px] py-10">
          <div className="z-10 absolute -left-1 md:left-[40px] bg-[#121127] h-[30px] md:h-[60px] mt-3 md:mt-0 rounded-full  ">
            {props.inViewport ? (
              <img
                src={activeToken}
                alt=""
                className="w-[30px] ml-[3px] lg:mt-[5px] mt-[5px] md:w-full"
              />
            ) : (
              <img src={handIcon} className="w-[30px] md:w-full" alt="" />
            )}
          </div>
          <div className="w-full pb-4">
            <p className="mb-7 mt-4  text-white font-bold text-xl md:text-2xl">
              <span className="text-lg lg:text-[22px] mr-3 text-transparent bg-clip-text bg-gradient-to-r from-[#8926B6] to-[#EABCFF]">
                {props.number}{" "}
              </span>
              <span className="text-white text-md md:text-[33px] ">
                {props.title}
              </span>
              <span className="text-[#747397] text-sm md:text-[22px] font-[300]">
                {props.subtitle}
              </span>
            </p>

            {props.details}
          </div>
        </div>
      </div>{" "}
      *
    </div>
  );
}

export default Timeline;
